<template>
  <div class="retailers-container" ref="retailers" id="retailers">
    <RibbonTitle title="¿Dónde Comprar?"></RibbonTitle>
    <div class="retailers_content">
        <div class="tiendas">
          <div class="row">
            <a
              href="https://www.amazon.com.mx/Cerveza-Miller-High-Botella-940ml/dp/B086YB72VY"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('Amazon', ' Ecommerce')"
            >
              <img :src="amazonImage" alt="Amazon" class="img-retas">
            </a>
            <a
              href="https://articulo.mercadolibre.com.mx/MLM-766217196-cerveza-miller-high-life-1x12-bot-32oz-_JM"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('Mercado Libre', ' Ecommerce')"
            >
              <img :src="mercadolibreImage" alt="Mercado Libre" class="img-retas">
            </a>
            <a
              href="https://super.walmart.com.mx/cervezas/cerveza-clara-miller-high-life-946-ml/00003410000031?gclsrc=aw.ds&&gclid=CjwKCAjw5p_8BRBUEiwAPpJO6zbvz69bch6Rfrku1SUNOMap0MgfBCFKOyvrHbJu-d-GtAif8blCsRoCrTYQAvD_BwE&gclsrc=aw.ds"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('Walmart', ' Ecommerce')"
            >
              <img :src="walmartImage" alt="Walmart" class="img-retas">
            </a>
            <a
              href=" https://super.walmart.com.mx/cervezas/cerveza-clara-miller-high-life-946-ml/00003410000031"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('Superama', ' Ecommerce')"
            >
              <img :src="superamaImage" alt="Superama" class="img-retas">
            </a>
          </div>
          <div class="row">
            <a
              href="https://www.heb.com.mx/vinos-y-licores/cerveza/importada/miller-high-lif-cerveza-clara-botella-946-ml-102016.html"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('H.E.B.', ' Ecommerce')"
            >
              <img :src="hebImage" alt="H.E.B." class="img-retas">
            </a>
            <a
              href="https://cornershopapp.com/es-mx/brands/erp-miller-high-life"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('Cornershop', ' Ecommerce')"
            >
              <img :src="cornershopImage" alt="Cornershop" class="img-retas">
            </a>
            <a
              href="https://bnc.lt/scMl/D61Wb4AvT0"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('Rappi', ' Ecommerce')"
            >
              <img :src="rappiImage" alt="Rappi" class="img-retas">
            </a>
            <a
              href="https://glup.com/"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('Glup', ' Ecommerce')"
            >
            <!--<a
              href="https://www.sixtogo.com.mx/miller-high-life-1x12-bot-32oz.html"
              target="_blank"
              @click="onEvib2cOutboundlinkPush('SixToGo', ' Ecommerce')"
            >
              <img :src="sixtogoImage" alt="SixToGo" class="img-retas">-->
              <img :src="glupImage" alt="Glup" class="img-retas">
            </a>
          </div>
        </div>
    </div>
    <div class="reta-cobertura">
      <!--<p>*Sujeto a cobertura del retailer. Six to Go sólo aplica para Monterrey.</p>-->
      <p>*Sujeto a cobertura del retailer.</p>
    </div>
    <br>
  </div>
</template>

<script>
import amazon from "@/assets/retailers/amazon.jpeg";
import mercadolibre from "@/assets/retailers/mercadolibre.jpeg";
import walmart from "@/assets/retailers/walmart.jpeg";
import superama from "@/assets/retailers/superama1.png";
import heb from "@/assets/retailers/heb.jpeg"
import cornershop from "@/assets/retailers/cornershop.jpeg"
import rappi from "@/assets/retailers/rappi.jpeg"
import sixtogo from "@/assets/retailers/sixtogo.jpeg"
import glup from "@/assets/retailers/glup.png";

import { mapActions, mapGetters } from "vuex";

import RibbonTitle from "@/components/RibbonTitle";

//Implementar tag
import tagFunctions from "../utils/tagFunctions";

export default {
  name: "Retailers",
  components: {
    RibbonTitle
  },
  computed: {
    ...mapGetters([""])
  },
  data() {
    return {
      amazonImage: amazon,
      mercadolibreImage: mercadolibre,
      walmartImage: walmart,
      superamaImage: superama,
      hebImage: heb,
      cornershopImage: cornershop,
      rappiImage: rappi,
      sixtogoImage: sixtogo,
      glupImage: glup,
    };
  },
  methods: {
    ...mapActions({}),
    //Implementar tag ib2c Outboundlink Events
    onEvib2cOutboundlinkPush(name, tipo) {
      tagFunctions.evib2cOutboundlinkPush(name, tipo)
    },
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/retailers.scss";
</style>